import React from 'react'
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

const CurrencyRow = ({ id, name, iso, setCurrency = () => { }, currency, setSelected = () => { }, openModal = () => { } }) => {

    return (
        <tr key={id} className={classNames({ 'bg-secondary text-white': currency === id })}>
            <td className='align-middle w-25 cursor-pointer' onClick={() => { setCurrency(id); setSelected({ id, name, iso }); }}><b>{name}</b></td>
            <td className='align-middle text-center'>{iso}</td>
            <td className='align-middle text-center'>
                <UncontrolledDropdown direction="left">
                    <DropdownToggle color="falcon-default" size="sm">
                        <FontAwesomeIcon icon="ellipsis-h" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem onClick={() => {
                            setSelected({ id, name, iso });
                            openModal(true);
                        }}>Editar</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </td>
        </tr>
    )
}

export default CurrencyRow;